export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS";
export const GET_PERMISSIONS_FAIL = "GET_PERMISSIONS_FAIL";

export const EDIT_PERMISSIONS = "EDIT_PERMISSIONS";
export const EDIT_PERMISSIONS_SUCCESS = "EDIT_PERMISSIONS_SUCCESS";
export const EDIT_PERMISSIONS_FAIL = "EDIT_PERMISSIONS_FAIL";
